<template>
  <dropdown
    ref="dropdown"
    :width="width"
    :placement="placement"
    margin-top="8"
    :disabled="disabled"
    class="dropdown-menu"
    popover-class="group-dropdown-menu-popover"
    @show="show"
    @hide="hide"
  >
    <template v-slot:reference>
      <slot>
        <el-button>默认按钮</el-button>
      </slot>
    </template>
    <template>
      <div class="dropdown-container" :style="{ maxHeight: maxHeight + 'px' }">
        <el-input
          ref="searchInput"
          placeholder="搜索"
          prefix-icon="el-icon-search"
          v-model="searchText"
          style="z-index: 1;padding: 6px;box-sizing: border-box;"
        ></el-input>
        <div v-if="_.isEmpty(filteredGroupList)" class="is-empty">
          无数据
        </div>
        <div ref="scrollWrapper" v-ps v-else>
          <group-dropdown-item
            v-for="(group, idx) in filteredGroupList"
            :key="idx"
            :active="curGroup === idx"
            :group="group"
            @group-click="toggleGroupState(idx)"
            @select="handleClick"
            :selected="selected"
            :explain="explain"
          ></group-dropdown-item>
        </div>
      </div>
    </template>
  </dropdown>
</template>

<script>
import Dropdown from "@/components/UIComponents/Dropdown"
import GroupDropdownItem from "@/components/UIComponents/GroupDropdownMenu/GroupDropdownItem"
import { filterTreeVarGroup } from "@/utils/workFlow"

export default {
  name: "group-dropdown-menu",
  components: { Dropdown, GroupDropdownItem },
  props: {
    groupList: {
      type: Array,
      default: () => [
        {
          label: "分组名",
          // title: "分组名", // 也可
          options: [{ label: "选项名", value: "选项值" }],
          children: [] // 子分组
        }
      ]
    },
    width: {
      type: String,
      default: "300"
    },
    placement: String,
    disabled: Boolean,
    explain: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    filteredGroupList() {
      if (!this.searchText) return this.groupList
      return filterTreeVarGroup({
        varGroup: this.groupList,
        filterFunc: option => option.label?.includes(this.searchText)
      })
    }
  },
  data() {
    return {
      curGroup: -1,
      searchText: "",
      maxHeight: 0
    }
  },
  mounted() {
    this.maxHeight = document.body.clientHeight - 50
  },
  methods: {
    open() {
      this.$refs.dropdown.open()
    },
    close() {
      this.$refs.dropdown.close()
    },
    handleClick({ option, group }) {
      this.close()
      this.$emit("select", option, group)
    },
    toggleGroupState(groupIndex) {
      if (groupIndex === this.curGroup) {
        this.curGroup = -1
      } else {
        this.curGroup = groupIndex
      }
      setTimeout(() => this.$refs.scrollWrapper._ps_?.update(), 300) // 动画需要0.3s
    },
    show() {
      this.$emit("show")
      this.searchText = ""
      this.$nextTick(() => {
        this.$refs.searchInput.focus()
        // 根据当前popover弹出位置,计算popover的最大高度
        this.maxHeight =
          document.body.clientHeight - this.$refs.dropdown.$refs.popover.$refs.popper.offsetTop - 7
      })
    },
    hide() {
      this.curGroup = -1
      this.$emit("hide")
    }
  }
}
</script>

<style lang="scss" scoped>
.group-dropdown-menu-popover {
  .is-empty {
    @include flex-center;
    height: 40px;
    color: $color-font-second;
  }
  .dropdown-container {
    display: flex;
    flex-flow: column;
    overflow: hidden;
    max-height: calc(100vh - 50px);
  }
}
</style>
